import './DropzoneContainer.scss';

import { Trans, useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';

import ErrorInfo from 'components/ErrorInfo/ErrorInfo';
import { ReactComponent as FileDragAndDropIcon } from 'images/icons/FileDragAndDrop.svg';
import Paragraph from 'components/TextComps/Paragraph';
import { observer } from 'mobx-react-lite';
import { useDropzone } from 'react-dropzone';
import { useStores } from 'index';

type Props = {
  validateInvites: () => void;
};

export const DropzoneContainer = observer(({ validateInvites }: Props) => {
  const { t } = useTranslation();
  const iss = useStores().inviteStudentsStore;
  const [uploadedFileError, setUploadedFileError] = useState<string>('');

  const { fileRejections, getRootProps, getInputProps } = useDropzone({
    accept: ['text/csv', '.csv'],
    onDrop: (acceptedFiles) => {
      setUploadedFileError('');
      if (acceptedFiles.length) iss.extractStudentsFromCSV(acceptedFiles[0]);
    },
  });

  useEffect(() => {
    if (fileRejections.length) {
      setUploadedFileError(`${t('FileRejected', { ns: 'studentsPage' })}: ${fileRejections[0].errors[0].message}`);
    }
  }, [fileRejections, t]);

  return (
    <div className='step dropzone-container'>
      <Paragraph>
        <Trans i18nKey='Step2UploadTheStudentList' ns='studentsPage'>
          <strong>Step 2</strong> Upload the Student list
        </Trans>
      </Paragraph>
      <div {...getRootProps({ className: 'dropzone' })}>
        <input {...getInputProps()} />
        <FileDragAndDropIcon />
        <Paragraph>
          <strong>{t('DragAndDrop', { ns: 'studentsPage' })}</strong>
        </Paragraph>
        <Paragraph>
          <>{t('DragAndDropHint', { ns: 'studentsPage' })}</>
        </Paragraph>
      </div>
      {uploadedFileError !== '' ? <ErrorInfo errorMsg={uploadedFileError} /> : null}
    </div>
  );
});

export default DropzoneContainer;
